const timezoneNames = [
  {
    label: 'Hawaii',
    value: 'Pacific/Honolulu',
    utc: '-10:00'
  },
  {
    label: 'Alaska',
    value: 'America/Anchorage',
    utc: '-08:00'
  },
  {
    label: 'Pacific',
    value: 'America/Los_Angeles',
    utc: '-07:00'
  },
  {
    label: 'Mountain',
    value: 'America/Denver',
    utc: '-06:00'
  },
  {
    label: 'Central',
    value: 'America/Chicago',
    utc: '-05:00'
  },
  {
    label: 'Eastern',
    value: 'America/New_York',
    utc: '-04:00'
  },
  {
    label: 'Arizona',
    value: 'America/Phoenix',
    utc: '-07:00'
  }
];

export default timezoneNames;
